import {FC} from "react";
import {Box, BoxProps} from "@mui/material";
import {AdminHeader} from "../../../../AdminHeader";
import {makeStyles} from "tss-react/mui";
import {useApi} from "@buildwitt/shapeshift-identity";
import {IAdminUsersLessonsResponseEntry, ILocalizationEntity, IAdminUsersGroupsResponseEntry, IAdminUsersCoursesResponseEntry, IEntity} from "@buildwitt/shapeshift-types";
import {AdminTable, AdminTableProps} from "@/components/common/table";
import {useNavigate} from "react-router-dom";
import {GRID_CHECKBOX_SELECTION_COL_DEF} from "@mui/x-data-grid-pro";
import { IBaseSearchDTO } from "@/components/common/table/AdminTable";

const useStyles = makeStyles()((theme) => ({
	contentBox: {
		marginTop: theme.spacing(3),
		padding: theme.spacing(2.5),
		backgroundColor: theme.palette.background.paper,
		borderWidth: theme.borderWidth.small,
		borderColor: theme.palette.grey[100],
		borderStyle: "solid",
		borderRadius: theme.borderRadius.small
	},
	lessonsAdminTable: {
		padding: 0,
		border: 0
	}
}));

interface ICustomProps {
	playlistId: number,
	playlist?: IAdminUsersGroupsResponseEntry
}

export type IProps = Omit<BoxProps, "children"> & ICustomProps;

const headCells = (locales?: ILocalizationEntity[]): AdminTableProps<"course", IAdminUsersCoursesResponseEntry>["columns"] => ([
	{
		...GRID_CHECKBOX_SELECTION_COL_DEF,
		type: "string",
		hideable: false
	},
	{
		field: "title",
		type: "string",
		flex: 1,
		headerName: "Title",
		minWidth: 240
	},
	{
		field: "updatedAt",
		type: "date",
		flex: 1,
		headerName: "Last Modified",
		valueGetter: (e) => e.value ? new Date(e.value).toLocaleDateString() : ""
	},
	{
		field: "languages",
		type: "string",
		flex: 1,
		sortable: false,
		headerName: "Supported Languages",
		valueGetter: ({value}: {value: IAdminUsersLessonsResponseEntry["languages"]}) => value?.map(e => locales?.find(x => x.code === e)?.name)?.join(", ")
	}
]);


export const CoursesTab: FC<IProps> = ({playlistId, playlist, ...baseProps}) => {
	const {classes} = useStyles();
	const [locales] = useApi<ILocalizationEntity[]>("/api/settings/i18n");
	const navigate = useNavigate();

	return <Box {...baseProps}>
		<Box className={classes.contentBox}>
			<AdminHeader title={`${playlist?.title} Courses`} />
			<AdminTable<"course", IAdminUsersCoursesResponseEntry, IBaseSearchDTO<IEntity> & {extendedAccess?: boolean}>
				className={classes.lessonsAdminTable}
				searchDTOverride={() => ({extendedAccess: true})}
				url={"/api/strapi-plugin-shapeshift-lms/cohort/group/" + playlistId + "/courses"}
				columns={headCells(locales.data)}
				filterMode="server"
				paginationMode="server"
				sortingMode="server"
				onEditAction={e => navigate("/admin/courses/" + e.id.toString())}
				type="course"
			/>
		</Box>
	</Box>
}